import { apiFetch } from '../../../lib/api';
import { chunkArray } from '../../../lib/school/schoolUsersBulkChunks';

/**
 * @param {string} schoolId
 * @param {{ rows: object[], options?: object }} body
 * @param {string} [token]
 */
export const validateSchoolUsersImport = async (schoolId, body, token) =>
  apiFetch(`/api/v1/schools/${schoolId}/users/import/validate`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: JSON.stringify(body),
  });

/**
 * @param {string} schoolId
 * @param {{ rows: object[], validation_token?: string|null, draft_id?: string|null, options?: object }} body
 * @param {string} [token]
 */
export const executeSchoolUsersImport = async (schoolId, body, token) =>
  apiFetch(`/api/v1/schools/${schoolId}/users/import`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: JSON.stringify(body),
  });

/**
 * @param {string} schoolId
 * @param {{ items: object[], options?: { mode?: string, dry_run?: boolean } }} body
 * @param {string} [token]
 */
export const bulkRemoveSchoolUsers = async (schoolId, body, token) =>
  apiFetch(`/api/v1/schools/${schoolId}/users/bulk-remove`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: JSON.stringify(body),
  });

/**
 * Runs bulk-remove in chunks of 50 (backend limit SCHOOL_BULK_TOO_LARGE).
 */
export async function bulkRemoveSchoolUsersChunked(schoolId, items, options, token) {
  const merged = { removed: [], failed: [], warnings: [], dry_run: options?.dry_run ?? false };
  const chunks = chunkArray(items);

  for (let i = 0; i < chunks.length; i += 1) {
    const res = await bulkRemoveSchoolUsers(
      schoolId,
      { items: chunks[i], options },
      token,
    );
    merged.removed.push(...(res.removed || []));
    merged.failed.push(...(res.failed || []));
    merged.warnings.push(...(res.warnings || []));
    if (res.dry_run != null) merged.dry_run = res.dry_run;
  }

  return merged;
}

/**
 * @param {string} schoolId
 * @param {string} [token]
 */
export const getSchoolUsersEmailDomain = async (schoolId, token) =>
  apiFetch(`/api/v1/schools/${schoolId}/users/email-domain`, {
    method: 'GET',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
